export default "__VITE_ASSET__ltmE$aGO__"